import type { Translator } from "../i18n/resolve";
import { escapeAttr } from "../utils/escape";

export const renderStarRating = (rating: number, translate: Translator): string => {
  const safeRating = Math.max(0, Math.min(5, Math.round(rating)));
  const filled = "★".repeat(safeRating);
  const empty = "☆".repeat(5 - safeRating);
  const label = translate("starRatingAria", { count: safeRating });
  return `<span class="mbn-stars" role="img" aria-label="${escapeAttr(label)}">${filled}${empty}</span>`;
};
